import { SearchHit, SearchHitTypes } from "frontend/types";

export function isSearchHitType<T extends SearchHit>(
  hitType: SearchHitTypes,
  searchHit?: SearchHit,
): searchHit is T {
  if (searchHit === undefined) return false;

  if (hitType === "modern") {
    return "url" in searchHit && "title" in searchHit;
  }
  if (hitType === "hollis") {
    return "title" in searchHit;
  }
  if (hitType === "modernArticle") {
    return (
      "contentType" in searchHit &&
      (searchHit.contentType === "Article" ||
        searchHit.contentType === "Citation")
    );
  }
  if (hitType === "risPublication") {
    return (
      "url" in searchHit &&
      "title" in searchHit &&
      "subset" in searchHit &&
      Array.isArray(searchHit.subset) &&
      (searchHit.subset.includes("ris-products") ||
        searchHit.subset.includes("ris-publications"))
    );
  }
  if (hitType === "risHonorsAwards") {
    return (
      "url" in searchHit &&
      "title" in searchHit &&
      "contentType" in searchHit &&
      searchHit.contentType === "Honors and Awards"
    );
  }
  if (hitType === "modernProgram") {
    return "contentType" in searchHit && searchHit.contentType === "Program";
  }
  if (hitType === "modernCourse") {
    return "contentType" in searchHit && searchHit.contentType === "Course";
  }
  if (hitType === "legacy" || hitType === "legacyArticle") {
    return "HBSLink" in searchHit && "HBSTitle" in searchHit;
  }

  if (hitType === "knowledgeSuggest") {
    return "Faculty" in searchHit && "suggestions" in searchHit;
  }

  return false;
}
